import React, { useState, useEffect } from "react";
import "../../../../assets/css/cms/tools.css";
import { Link, useParams } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { Formik } from "formik";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import { Step, StepLabel, Stepper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { postBasicDetails, postInputPageToolContent, postInputPageFaqContent, postInputPageDetails, postResultPage } from "../../../../../store/actions/cms/predictorTools";
import { clearPostResultPageResponse, clearPostBasicDetailResponse, clearInputToolContentResponse, clearPostInputDetailResponse, clearPostBasicDetailMessageResponse, clearPostInputPageFaqResponse } from "../../../../../store/slices/managePredictorTools";
import InputPageAddEdit from "./inputPageAddEdit";
import BasicDetail from "./basicDetail";
import ResultPage from "./resultPage";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { CHECK_PERMISSION, DEFAULT_SMART_REGISTRATION_FLOW } from "../../../../constants/cms";
import PermissionDenied from "../../../cms/common/permissionDenied"

export const headerSectionCard = "";
export const toolContent = {
  id: "",
  heading: "",
  image_web: "",
  image_wap: "",
  content: "",
};
export const FAQs = { id: "", question: "", answer: "" };

const PredictorAddEdit = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { type, id } = useParams();
  const { predictorToolTypeData, predictorExamDropdownData, predictorToolAuthorData,
    basicDetailData, postBasicDetailData, inputDetailData, inputPageFaqData, postBasicDetailDataError,
    resultPageData, postResultPageData, postInputToolContentData, postInputPageFaqData,
    postInputDetailData, inputToolContentData, resultFormMessage, postResultPageError, basicFormMessage,
    postInputDetailError,
    postInputToolContentError, postInputPageFaqError,
    inputDetailError, inputToolContentError, inputPageFaqError, basicDetailError
  } = useSelector(state => state.predictorToolsReducer)
  const { userPermission } = useSelector((state) => {
    return state.userData;
  });
  const { user } = useSelector((state) => state.userData);
  const [initialValues, setInitialValues] = useState({

    // type: { id: 'result_predictor', value: 'Result Predictors', selected: false },
    // name: "",
    // exam: "",
    // usage_count_matrix: "",
    // positive_feedback_percentage: "",
    // for_web: null,
    // app_status: false,

    // page_title: "",
    // url_alias: "",
    // meta_description: "",
    // keywords: "",

    // display_preference: 0,
    // video: "",
    // gif: "",
    // image: "",
    // secondary_image: "",
    // smart_registration: 0,
    // smart_registration_flow: DEFAULT_SMART_REGISTRATION_FLOW,
    // display_name_type: 1,
    // custom_exam_name: "",
    // custom_flow_type: "",
    // custom_year: "",
    // alias: "",
    // listing_desc: "",
    // page_title: "",
    // url_alias: "",
    // meta_description: "",
    // keywords: "",
    // header_section: [headerSectionCard],
    // data: [toolContent],
    // response: [FAQs],
    // exam_other_content: "",
    // exam_content_author: null,

    // rp_disclaimer: "",
    // cp_cta_name: "",
    // cp_destination_url: "",
    // cp_pitch: "",
    // mapped_product_title: "",
    // mapped_product_cta_label: "",
    // mapped_product_destination_url: "",
    // mapped_product_pitch: "",
    // promotion_banner_web: "",
    // promotion_banner_wap: "",
    // banner_destination: "",
    // enable_cp_pitch_for_rp: false,
    // cp_pitch_for_rp: ""

  })
  const [saveNext, setSaveNext] = useState(false)
  const [activeStep, setActiveStep] = useState(type == "basic-form" ? 0 : type == "input-form" ? 1 : 2);
  const navigate = useNavigate();

  // function to show tooltip message against field
  const showInfoTip = (fieldType) => {
    const infoMessages = {
      usage_count_matrix:
        "Enter usage count to be shown on landing page, example: 3M+, 40K+.",
      positive_feedback_percentage:
        "Enter positive feedback percentage to be shown on landing page, example: 97%",
      cp_checkbox:
        "The checkbox is non-mandatory, but if selected, the 'CP Pitch for RP Input Page' and the three fields above for college predictor mapping will become mandatory.",
    };

    const info = infoMessages[fieldType] || "";

    return (
      <span className="info_tip">
        <HiOutlineInformationCircle /> <span className="info">{info}</span>
      </span>
    );
  };


  // Steps definition
  const steps = ["Basic Detail", "Input Page Detail", "Result Page"];
  const stepRoutes = [
    `/cms/tools/manage-predictor/basic-form/${id ? id : postBasicDetailData?.product_id || ""}`,
    `/cms/tools/manage-predictor/input-form/${id ? id :postBasicDetailData?.product_id || ""}`,
    `/cms/tools/manage-predictor/result-form/${id ? id : postBasicDetailData?.product_id || ""}`,
  ];
  const handleStepChange = (stepIndex) => {
    setActiveStep(stepIndex); // Update active step
    navigate(stepRoutes[stepIndex]); // Navigate to the route corresponding to the step
  };

  const showBlockForSEO = () => {
    let authorized = false;
    const userPermissions = userPermission?.data;

    if (userPermissions) {
      authorized = userPermissions.some(permission => {
        return permission.codename === CHECK_PERMISSION?.content_seo_application && permission.name === CHECK_PERMISSION?.content_seo_action
      });
    }
    return authorized;
  }

  useEffect(() => {
    const stepFromURL = stepRoutes.indexOf(location.pathname);
    if (stepFromURL !== -1) {
      setActiveStep(stepFromURL);
    }
  }, [location]);

  useEffect(() => {
    if (inputDetailData) {
      let obj = { ...inputDetailData }
      obj.header_section = inputDetailData?.header_section ?? [headerSectionCard]
      obj.display_name_type = inputDetailData?.display_name_type ?? "1",
        obj.exam_content_author = (inputDetailData?.exam_content_author_id || inputDetailData?.exam_content_author__name)
          ? {
            id: inputDetailData?.exam_content_author_id,
            value: inputDetailData?.exam_content_author__name
          }
          : null;

      setInitialValues(prevState => ({
        ...prevState,
        ...obj,
      }));
    }

  }, [inputDetailData])
  useEffect(() => {
    if (inputToolContentData) {
      setInitialValues(prevState => ({
        ...prevState,
        data: inputToolContentData?.length == 0 ? [toolContent] : inputToolContentData, // Assigning inputToolContentData to the "data" key
      }));
    }
  }, [inputToolContentData]);

  useEffect(() => {
    if (inputPageFaqData) {
      setInitialValues(prevState => ({
        ...prevState,
        response: inputPageFaqData?.response?.length > 0 ? inputPageFaqData?.response : [FAQs], // Assigning inputPageFaqData to the "response" key
      }));
    }
  }, [inputPageFaqData]);

  useEffect(() => {
    if (resultPageData) {
      setInitialValues(prevState => ({
        ...prevState,
        ...resultPageData
      }));
    }
  }, [resultPageData])

  useEffect(() => {
    if (postBasicDetailData && saveNext) {
      setTimeout(() => {
        navigate(`/cms/tools/manage-predictor/input-form/${postBasicDetailData?.product_id || id}`)
        setActiveStep(1);
      }, [1000])
    }
    // if (postBasicDetailData) {
    //   setTimeout(() => {
    //     navigate(`/cms/tools/manage-predictor/basic-form/${postBasicDetailData?.product_id || id}`)
    //     setActiveStep(1);
    //   }, [1000])
    // }

    if (postBasicDetailDataError) {
      setTimeout(() => {
        dispatch(clearPostBasicDetailResponse())
        dispatch(clearPostBasicDetailMessageResponse())
      }, [2000])
    }
  }, [(postBasicDetailData || postBasicDetailDataError)])

  useEffect(() => {
    if (postInputDetailData && postInputPageFaqData && postInputToolContentData && saveNext) {
      setTimeout(() => {
        navigate(`/cms/tools/manage-predictor/result-form/${id}`)
        setActiveStep(2)
        dispatch(clearPostInputPageFaqResponse());
        dispatch(clearPostInputDetailResponse());
        dispatch(clearInputToolContentResponse());
      }, 1000);
    }
    if (postInputDetailData && postInputPageFaqData && postInputToolContentData) {
      setTimeout(() => {
        dispatch(clearPostInputPageFaqResponse());
        dispatch(clearPostInputDetailResponse());
        dispatch(clearInputToolContentResponse());
      }, 1000);
    }
    if (postInputDetailError && postInputToolContentError && postInputPageFaqError) {
      setTimeout(() => {
        dispatch(clearPostInputPageFaqResponse());
        dispatch(clearPostInputDetailResponse());
        dispatch(clearInputToolContentResponse());
      }, 2000);
    }
  }, [(postInputDetailData || postInputDetailError) && (postInputPageFaqData || postInputPageFaqError) && (postInputToolContentData || postInputToolContentError)]);

  useEffect(() => {
    if (postResultPageData) {
      setTimeout(() => {
        navigate('/cms/tools/manage-predictor')
        dispatch(clearPostResultPageResponse());
      }, [1000])
    }
    if (postResultPageError) {
      setTimeout(() => {
        dispatch(clearPostResultPageResponse());
      }, [2000])
    }
  }, [(postResultPageData || postResultPageError)])

  useEffect(() => {
    if (basicDetailData) {
      setInitialValues({
        type: predictorToolTypeData?.tools_type?.find((item) => item?.id == basicDetailData?.basic_detail?.type) ||
          { id: 'result_predictor', value: 'Result Predictors', selected: false },
        name: basicDetailData?.basic_detail?.name || "",
        exam: {
          id: basicDetailData?.basic_detail?.exam_id, exam_name: basicDetailData?.basic_detail?.exam_name,
          exam_short_name: basicDetailData?.basic_detail?.exam_short_name
        },
        usage_count_matrix: basicDetailData?.basic_detail?.usage_count_matrix || "",
        positive_feedback_percentage: basicDetailData?.basic_detail?.positive_feedback_percentage || "",
        for_web: basicDetailData?.basic_detail?.for_web,
        app_status: basicDetailData?.basic_detail?.app_status == "published" ? true : false,

        page_title: basicDetailData?.seo_detail?.page_title || "",
        url_alias: basicDetailData?.seo_detail?.url_alias || "",
        meta_description: basicDetailData?.seo_detail?.meta_description || "",
        keywords: basicDetailData?.seo_detail?.keywords || "",

        display_preference: basicDetailData?.input_page_media?.display_preference || 0,
        video: basicDetailData?.input_page_media?.video || "",
        gif: basicDetailData?.input_page_media?.gif || "",
        image: basicDetailData?.input_page_media?.image || "",
        secondary_image: basicDetailData?.input_page_media?.secondary_image || "",
        sponser_logo: basicDetailData?.input_page_media?.sponser_logo || "",
        client_banner: basicDetailData?.input_page_media?.client_banner || "",
        client_banner_url: basicDetailData?.input_page_media?.client_banner_url || "",
        enable_sponser_logo: basicDetailData?.input_page_media?.enable_sponser_logo || 0,
        smart_registration: basicDetailData?.input_page_media?.smart_registration || 0,
        smart_registration_flow: DEFAULT_SMART_REGISTRATION_FLOW.map((defaultItem) => {
          const existingItem = basicDetailData?.smart_registration_flow?.find(item => item.id === defaultItem.id);
          return existingItem ? existingItem : defaultItem;
        }),
        header_section: [headerSectionCard],
        data: [toolContent],
        response: [FAQs],

        //input page detail
        display_name_type: 1,
      })
    }
  }, [basicDetailData, predictorToolTypeData, predictorExamDropdownData])

  useEffect(() => {
    if (activeStep == 0) {
      setInitialValues({
        type: { id: 'result_predictor', value: 'Result Predictors', selected: false },
        name: "",
        exam: "",
        usage_count_matrix: "",
        positive_feedback_percentage: "",
        for_web: null,
        app_status: false,

        page_title: "",
        url_alias: "",
        meta_description: "",
        keywords: "",

        display_preference: 0,
        video: "",
        gif: "",
        image: "",
        secondary_image: "",
        sponser_logo: "",
        client_banner: "",
        client_banner_url: "",
        enable_sponser_logo: 0,
        smart_registration: 0,
        smart_registration_flow: DEFAULT_SMART_REGISTRATION_FLOW
      })
    }
    if (activeStep == 1) {
      setInitialValues({
        display_name_type: 1,
        custom_exam_name: "",
        custom_flow_type: "",
        custom_year: "",
        alias: "",
        listing_desc: "",
        page_title: "",
        url_alias: "",
        meta_description: "",
        keywords: "",
        header_section: [headerSectionCard],
        data: [toolContent],
        response: [FAQs],
        exam_other_content: "",
        exam_content_author: null,
      })
    }
    if (activeStep == 2) {
      setInitialValues({
        rp_disclaimer: "",
        cp_cta_name: "",
        cp_destination_url: "",
        cp_pitch: "",
        mapped_product_title: "",
        mapped_product_cta_label: "",
        mapped_product_destination_url: "",
        mapped_product_pitch: "",
        promotion_banner_web: "",
        promotion_banner_wap: "",
        banner_destination: "",
        enable_cp_pitch_for_rp: false,
        cp_pitch_for_rp: ""
      })
    }
  }, [activeStep])

  // Function to handle image validation
  const handleImage = (obj, maximumWidth, maximumHeight) => {
    return new Promise((resolve, reject) => {
      const maxWidth = maximumWidth;
      const maxHeight = maximumHeight;
      let imageError = null;
      if (typeof obj !== "undefined" && obj instanceof Blob) {
        // Check if obj is a Blob
        var reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            if (
              height < maxHeight ||
              width < maxWidth ||
              maxWidth / maxHeight !== width / height
            ) {
              imageError = `Please upload in ${maxWidth}*${maxHeight} size.`;
            }
            resolve(imageError);
          };
          image.onerror = function () {
            reject("Failed to load image");
          };
        };
        reader.readAsDataURL(obj);
      } else {
        resolve(imageError);
      }
    });
  };

  const handleImageMax = (obj, maximumWidth, maximumHeight) => {
    return new Promise((resolve, reject) => {
      const maxWidth = maximumWidth;
      const maxHeight = maximumHeight;
      let imageError = null;
      if (typeof obj !== "undefined" && obj instanceof Blob) {
        // Check if obj is a Blob
        var reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            if (
              height > maxHeight ||
              width > maxWidth 
            ) {
              imageError = `Please upload less than ${maxWidth}*${maxHeight} size.`;
            }
            resolve(imageError);
          };
          image.onerror = function () {
            reject("Failed to load image");
          };
        };
        reader.readAsDataURL(obj);
      } else {
        resolve(imageError);
      }
    });
  };

  const handleImageMaxWidth = (obj, maximumWidth) => {
    return new Promise((resolve, reject) => {
      const maxWidth = maximumWidth;
      let imageError = null;
      if (typeof obj !== "undefined" && obj instanceof Blob) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            const width = this.width;
            if (width > maxWidth) {
              imageError = "Image dimensions must be Max 600W pixels.";
            }
            resolve(imageError);
          };
          image.onerror = function () {
            reject("Failed to load image");
          };
        };
        reader.readAsDataURL(obj);
      } else {
        resolve(imageError);
      }
    });
  };

  const handleGif = (obj, maximumWidth, maximumHeight) => {
    return new Promise((resolve, reject) => {
      const maxWidth = maximumWidth;
      const maxHeight = maximumHeight;
      let gifError = null;

      if (typeof obj !== "undefined" && obj instanceof Blob) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const gif = new Image();
          gif.src = e.target.result;
          gif.onload = function () {
            const height = this.height;
            const width = this.width;

            // Validate GIF dimensions and aspect ratio
            if (
              height < maxHeight ||
              width < maxWidth ||
              maxWidth / maxHeight !== width / height
            ) {
              gifError = `Please upload in ${maxWidth}x${maxHeight} size.`;
            }
            resolve(gifError);
          };
          gif.onerror = function () {
            reject("Failed to load GIF");
          };
        };
        reader.readAsDataURL(obj);
      } else {
        resolve(gifError); // Resolve with no error if obj is undefined or not a Blob
      }
    });
  };
  // Function for Formik validation
  const validate = async (values) => {
    const errors = {};
    if (activeStep === 0 && type == "basic-form") {
      // const youtubeEmbedUrlPattern = /^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+$/;
      const youtubeUrlPattern = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)[a-zA-Z0-9_-]+/;

      // Validation for 'type'
      if (!values?.type) {
        errors.type = "This is a mandatory field";
      }

      // Conditional validation for 'exam'
      if (values?.type?.id === "result_predictor" && !values?.exam) {
        errors.exam = "Please select an exam";
      }
      if (!values?.name?.trim()) {
        errors.name = "Please set the tool's CMS system name";
      } else if (values?.name?.trim().length > 100) {
        errors.name = "Tool's CMS system name can't exceed 100 characters.";
      }

      // Validation for 'positive_feedback_percentage'
      if (values?.positive_feedback_percentage?.trim()?.length > 10) {
        errors.positive_feedback_percentage = "Positive feedback percentage can't exceed 10 characters.";
      }

      // Validation for 'usage_count_matrix'
      if (values?.usage_count_matrix?.trim()?.length > 10) {
        errors.usage_count_matrix = "Usage count metric can't exceed 10 characters.";
      }
      // seo detail section
      if (!values?.page_title?.trim() && showBlockForSEO()) {
        errors.page_title = "Please set the tool’s page title."
      }
      else if (values?.page_title?.trim()?.length > 200) {
        errors.page_title = "Page Title can't exceed 200 characters."
      }

      if (!values?.url_alias?.trim() && showBlockForSEO()) {
        errors.url_alias = "Please set the tool’s alias url."
      }
      else if (values?.url_alias?.trim()?.length > 100) {
        errors.url_alias = "Url alias can't exceed 100 characters."
      }
      if (!values?.meta_description?.trim() && showBlockForSEO()) {
        errors.meta_description = "Please set the tool’s meta description."
      }
      else if (values?.meta_description?.trim()?.length > 600) {
        errors.meta_description = "Meta description can't exceed 100 characters."
      }

      if (values?.keywords?.trim()?.length > 600) {
        errors.keywords = "Keywords can't exceed 600 characters."
      }

      // Validation for 'display_preference'
      if (!values?.display_preference) {
        errors.display_preference = "Please select media display preference.";
      }
      // Validation for 'youtube'
      if (values?.video?.length > 100) {
        errors.video = "YouTube URL can't exceed 100 characters.";
      } else if (/\s/.test(values?.video)) {
        errors.video = "URL cannot contain spaces";
      } else if (values?.video && !youtubeUrlPattern.test(values?.video)) {
        errors.video = "Please enter a valid YouTube video URL";
      }

      // Validation for 'image'
      if (!values.image) {
        errors.image = "Please upload the tool's primary image.";
      } else {
        const imageError = await handleImage(values.image, 640, 360);
        if (imageError) {
          errors.image = imageError;
        }
      }

      // Validation for 'sponser_logo'  

      if (values.sponser_logo) {
        const imageError = await handleImageMax(values.sponser_logo, 250, 125);
        if (imageError) {
          errors.sponser_logo = imageError;
        }
      }

      // Validation for 'client_banner'
      if (values.client_banner) {
        const imageError = await handleImageMaxWidth(values.client_banner, 600);
        if (imageError) {
          errors.client_banner = imageError;
        }
      }

      if (values?.client_banner_url?.trim()?.length > 500) {
        errors.client_banner_url = "Destination URL can't exceed 500 characters.";
      }

      // Validation for 'secondary_image'     

      if (values.secondary_image) {
        const imageError = await handleImage(values.secondary_image, 640, 360);
        if (imageError) {
          errors.secondary_image = imageError;
        }
      }
      // Validation for 'gif'
      if (values.gif) {
        const imageError = await handleGif(values.gif, 640, 360);
        if (imageError) {
          errors.gif = imageError;
        }
      }
    }

    if (activeStep === 1 && type == "input-form") {
      // Ensure there’s at least one non-empty card.
      //   if (!values?.header_section || values.header_section.length === 0 || values.header_section.every((card) => card.trim() === "")) {
      //             errors.header_section = "Please set the tool’s header section content.";
      // }
      if (values?.header_section?.length > 0) {
        errors.header_section = []; // Initialize errors for the header section.

        // Loop through each index of the header array
        values.header_section.forEach((headerValue, index) => {
          if (!headerValue || headerValue?.trim() === "") {
            errors.header_section[index] = `Please set the tool's header section content.`;
          }
          if (headerValue?.trim()?.length > 200) {
            errors.header_section[index] = `Header Card content can't exceed 200 characters.`;
          }
        });

        // Clean up errors if no issues are present
        if (errors.header_section?.length === 0) {
          delete errors.header_section;
        }
      }

      // Validation for FAQs
      if (values?.response?.length > 0) {
        errors.response = []; // Initialize errors for FAQs.

        values.response.forEach((faq, index) => {
          if (faq?.question || faq?.answer) {
            // Validate Question
            if (!faq?.question || faq.question?.trim() === "") {
              errors.response[index] = errors.response[index] || {};
              errors.response[index].question = "Please set the question title.";
            } else if (faq.question?.trim().length > 200) {
              errors.response[index] = errors.response[index] || {};
              errors.response[index].question =
                "Question can't exceed 200 characters.";
            }

            // Validate Answer
            if (!faq?.answer || faq.answer?.trim() === "") {
              errors.response[index] = errors.response[index] || {};
              errors.response[index].answer = "Please set the answer.";
            }
          }
        });

        // Clean up errors if no issues are present.
        if (errors.response.length === 0) {
          delete errors.response;
        }
      }

      if (values?.data?.length > 0) {
        let hasErrors = false;
        errors.data = [];

        // Filter out empty objects
        const filteredData = values.data?.filter(card =>
          Object.keys(card)?.length > 0 &&
          (card.heading || card.content || card.image_web || card.image_wap)
        );

        for (const [index, card] of filteredData.entries()) {
          let cardErrors = {}; // Store errors for the current card

          // Validate Heading
          if (!card?.heading || card.heading.trim() === "") {
            cardErrors.heading = "Please set the content heading.";
          } else if (card.heading.trim().length > 50) {
            cardErrors.heading = "Heading can't exceed 50 characters.";
          }

          // Validate Content
          if (!card?.content || card.content.trim() === "") {
            cardErrors.content = "Please set the content description.";
          }

          // Image/GIF Web validation
          if (!card?.image_web) {
            cardErrors.image_web = "Please upload the content's image.";
          } else {
            const imageError = await handleImage(card.image_web, 373, 240);
            if (imageError) {
              cardErrors.image_web = imageError;
            }
          }

          // Image/GIF Mob validation
          if (!card?.image_wap) {
            cardErrors.image_wap = "Please upload the content's image.";
          } else {
            const imageError = await handleImage(card.image_wap, 373, 240);
            if (imageError) {
              cardErrors.image_wap = imageError;
            }
          }

          // Only add errors if there are validation failures
          if (Object.keys(cardErrors).length > 0) {
            errors.data[index] = cardErrors;
            hasErrors = true;
          }
        }

        // If no errors exist, remove the errors object
        if (!hasErrors) {
          delete errors.data;
        }
      }



      // input page content 
      if (values?.display_name_type == 1) {
        if (!values?.custom_exam_name?.trim()) {
          errors.custom_exam_name = "Please set the custom title's exam name component."
        }
        else if (values?.custom_exam_name?.trim()?.length > 40) {
          errors.custom_exam_name = "Exam Name can't exceed 40 characters."
        }
        if (!values?.custom_flow_type?.trim()) {
          errors.custom_flow_type = "Please set the custom title's flow type component."
        }
        else if (values?.custom_flow_type?.trim()?.length > 30) {
          errors.custom_flow_type = "Exam Name can't exceed 30 characters."
        }
        if (!values?.custom_year) {
          errors.custom_year = "Please set the custom title's year component."
        }
        else if (values?.custom_year?.length > 10) {
          errors.custom_year = "Year can't exceed 10 characters."
        }

      }
      if (values?.display_name_type == 2) {
        if (!values?.alias?.trim()) {
          errors.alias = "Please set the tool's display title."
        }
        else if (values?.alias?.trim()?.length > 100) {
          errors.alias = "Tool's display title can't exceed 100 characters."
        }
      }

      if (!values?.listing_desc?.trim()) {
        errors.listing_desc = "Please set the tool's listing description."
      }

      else if (values?.listing_desc) {
        const plainText = values.listing_desc.replace(/<\/?[^>]+(>|$)/g, "")?.trim();
        if (plainText?.trim()?.length > 200) {
          errors.listing_desc = "Word limit exceeded, please enter only 200 words.";
        }
      }
      if (values?.exam_other_content) {
        if (!values?.exam_content_author) {
          errors.exam_content_author = "Please select the Author."
        }
      }
      if (values?.exam_content_author) {
        if (!values?.exam_other_content) {
          errors.exam_other_content = "Please set other exam related content."
        }
      }
    }

    if (activeStep == 2 && type == "result-form") {
      // manage result page 
      if (values?.rp_disclaimer?.trim()?.length > 350) {
        errors.rp_disclaimer = "RP Disclaimer can't exceed 350 characters."
      }

      // map college predictor
      if (values?.cp_destination_url?.trim()?.length > 200) {
        errors.cp_destination_url = "Destination URL can't exceed 200 characters."
      }
      if (values?.cp_pitch?.trim()?.length > 200) {
        errors.cp_pitch = "College predictor’s pitch can't exceed 200 characters."
      }
      if (values?.cp_pitch_for_rp?.trim()?.length > 200) {
        errors.cp_pitch_for_rp = "CP pitch for RP can't exceed 200 characters."
      }
      if (values?.cp_cta_name?.trim()?.length > 40) {
        errors.cp_cta_name = "CTA label can't exceed 40 characters."
      }

      if (values?.cp_cta_name || values?.cp_destination_url || values?.cp_pitch) {
        if (!values?.cp_cta_name?.trim()) {
          errors.cp_cta_name = "Please set the CTA label."
        }
        if (!values?.cp_destination_url?.trim()) {
          errors.cp_destination_url = "Please set the Destination URL."
        }
        if (!values?.cp_pitch?.trim()) {
          errors.cp_pitch = "Please set the college predictor’s pitch."
        }
      }
      if (values.enable_cp_pitch_for_rp) {
        if (!values?.cp_pitch_for_rp?.trim()) {
          errors.cp_pitch_for_rp = "Please set the college predictor’s pitch for RP Input Page."
        }
        if (!values?.cp_cta_name?.trim()) {
          errors.cp_cta_name = "Please set the CTA label."
        }
        if (!values?.cp_destination_url?.trim()) {
          errors.cp_destination_url = "Please set the Destination URL."
        }
        if (!values?.cp_pitch?.trim()) {
          errors.cp_pitch = "Please set the college predictor’s pitch."
        }
      }



      // product Integration
      if (values?.mapped_product_title || values?.mapped_product_cta_label || values?.mapped_product_destination_url || values?.mapped_product_pitch) {
        if (!values?.mapped_product_title?.trim()) {
          errors.mapped_product_title = "Please set the product’s title."
        }
        else if (values?.mapped_product_title?.trim()?.length > 100) {
          errors.mapped_product_title = "Product’s title can't exceed 100 characters."
        }
        if (!values?.mapped_product_cta_label?.trim()) {
          errors.mapped_product_cta_label = "Please set the CTA label."
        }
        else if (values?.mapped_product_cta_label?.trim().length > 40) {
          errors.mapped_product_cta_label = "CTA label can't exceed 40 characters."
        }
        if (!values?.mapped_product_destination_url?.trim()) {
          errors.mapped_product_destination_url = "Please set the Destination URL."
        }
        else if (values?.mapped_product_destination_url?.trim()?.length > 200) {
          errors.mapped_product_destination_url = "Destination URL pitch can't exceed 200 characters."
        }
        if (!values?.mapped_product_pitch?.trim()) {
          errors.mapped_product_pitch = "Please set the product’s pitch."
        }
        else if (values?.mapped_product_pitch?.trim()?.length > 200) {
          errors.mapped_product_pitch = "Product’s pitch can't exceed 200 characters."
        }
      }

      if (values?.banner_destination || values?.promotion_banner_web || values?.promotion_banner_wap) {
        if (!values?.banner_destination?.trim()) {
          errors.banner_destination = "Please set the Destination URL."
        }
        else if (values?.banner_destination?.trim()?.length > 200) {
          errors.banner_destination = "Destination URL can't exceed 200 characters."
        }

        // Image/GIF Web validation
        if (!values?.promotion_banner_web) {
          errors.promotion_banner_web = "Please upload the banner.";
        }

        // Image/GIF Mob validation
        if (!values?.promotion_banner_wap) {
          errors.promotion_banner_wap = "Please upload the banner.";
        }
      }
    }
    return errors;
  };
  return (
    <div className="rp_tool_cover">
      <h4>Add/Edit Predictor Tool</h4>

      <div className={"custom_breadcrumb"}>
        <ul className={"custom_breadcrumb_ul"}>
          <li className={"custom_breadcrumb_list"}>
            <Link to="/cms/">
              <a className={"sub_nan_anchor"}>Home</a>
            </Link>
          </li>
          <li className={"custom_breadcrumb_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li
            className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}
          >
            <a className={"sub_nan_anchor"} href="/cms/tools/manage-predictor">
              Manage Predictor Tool
            </a>
          </li>
          <li className={"custom_breadcrumb_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li
            className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}
          >
            Add/Edit Predictor Tool
          </li>
        </ul>
      </div>
      <div className={"notification_popup"}>
        {basicFormMessage && (
          <Alert
            severity={
              postBasicDetailDataError
                ? `error`
                : `success`
            }
          >
            {" "}
            {basicFormMessage}{" "}
          </Alert>
        )}
        {((postInputToolContentData && postInputPageFaqData && postInputDetailData) ||
          (postInputDetailError || postInputToolContentError || postInputPageFaqError)) && (
            <Alert
              severity={
                postInputDetailError || postInputToolContentError || postInputPageFaqError
                  ? "error"
                  : "success"
              }
            >
              {postInputDetailError || postInputToolContentError || postInputPageFaqError
                ? "Something Went Wrong"
                : "Data Added Successfully"}
            </Alert>
          )}

        {(postResultPageData || postResultPageError) && (
          <Alert
            severity={
              postResultPageError
                ? `error`
                : `success`
            }
          >
            {" "}
            {postResultPageError ? "Something Went Wrong" : "Data Added Successfully"}{" "}
          </Alert>
        )}

      </div>

      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validate={validate}
        onSubmit={(values) => {
          if (activeStep == 0 && type == "basic-form") {
            let data = new FormData();
            // Append values to FormData
            if (id || postBasicDetailData?.product_id) {
              data.append("product_id", id || postBasicDetailData?.product_id)
            }
            data.append("type", values?.type?.id || null);
            data.append("exam", values?.exam?.id || 0);
            data.append("name", values?.name?.trim() || "");
            data.append("usage_count_matrix", values?.usage_count_matrix?.trim() || "");
            data.append("positive_feedback_percentage", values?.positive_feedback_percentage?.trim() || "");
            data.append("for_web", values?.for_web ? 1 : 0);
            data.append("app_status", values?.app_status ? "published" : "unpublished" || null);
            data.append("page_title", values?.page_title?.trim() || "");
            data.append("url_alias", values?.url_alias?.trim() || "");
            data.append("meta_description", values?.meta_description || "");
            data.append("meta_keywords", values?.keywords?.trim() || "");
            data.append("display_preference", values?.display_preference || 0);
            data.append("gif", values?.gif || "");
            data.append("image", values?.image || "");
            data.append("secondary_image", values?.secondary_image || "");
            data.append("sponser_logo", values?.sponser_logo || "");
            data.append("client_banner", values?.client_banner || "");
            data.append("client_banner_url", values?.client_banner_url || "");
            data.append("enable_sponser_logo", values?.enable_sponser_logo || 0);
            data.append("video", values?.video) || "";
            data.append("smart_registration", values?.smart_registration == true ? 1 : 0 || 0);

            const smartRegistrationData = values?.smart_registration_flow?.map((item) => ({
              id: item?.id,
              name: item.name,
              peak_season: item.peak_season,
              non_peak_season: item.non_peak_season

            }));

            // author_popular_content is getting empty keys so if entity search is not selected then passing author_popular_content as empty []
            if (values?.smart_registration) {
              data.append("smart_registration_data", smartRegistrationData?.length > 0 && JSON.stringify(smartRegistrationData));
            }
            data.append("consume_type", "free")
            data.append("created_by", user?.data?.id)
            data.append("updated_by", user?.data?.id)
            
            // Dispatching data
            dispatch(postBasicDetails(data));
          }
          if (activeStep == 1 && type == "input-form") {
            let data = new FormData();
            if (id) {
              data.append("product_id", id)
            }
            data.append("display_name_type", values?.display_name_type || "");
            if (values?.display_name_type == 1) {
              data.append("custom_exam_name", values?.custom_exam_name?.trim() || "");
              data.append("custom_flow_type", values?.custom_flow_type?.trim() || "");
              data.append("custom_year", values?.custom_year || "");
            }
            if (values?.display_name_type == 2) {
              data.append("alias", values?.alias?.trim() || "");
            }
            data.append("listing_description", values?.listing_desc);
            if (values?.exam_other_content) {
              data.append("exam_other_content", values?.exam_other_content);
            }
            if (values?.exam_content_author?.id && values?.exam_other_content) {
              data.append("exam_content_author", values?.exam_content_author?.id);
            }
            data.append("header_section", JSON.stringify(values?.header_section));
            data.append("created_by", user?.data?.id)
            data.append("updated_by", user?.data?.id)

            // Dispatching data
            dispatch(postInputPageDetails(data));

            let params = {};
            params.product_id = id;
            params.user_id = user?.data?.id;
            params.faqs = values?.response?.map((item) => ({
              ...item,
              question: item?.question?.trim() || "",
            }));

            dispatch(postInputPageFaqContent(params));


            const originalData = values?.data;

            // Initialize FormData
            const formData = new FormData();

            const dataArray = originalData?.map(({ id, heading, content }) => ({
              id,
              heading: heading?.trim() || "",
              content,
              created_by: user?.data?.id,
              updated_by: user?.data?.id
            }));

            // Append the data array to FormData under the key 'data'
            formData.append('data', JSON.stringify(dataArray));
            formData.append('product_id', id)

            // Append images to FormData with proper keys
            originalData.forEach((item, index) => {
              formData.append(`image_web_${index}`, item.image_web);
              formData.append(`image_wap_${index}`, item.image_wap);
            });

            dispatch(postInputPageToolContent(formData))

          }
          if (activeStep == 2 && type == "result-form") {
            let data = new FormData();
            if (id) {
              data.append("product_id", id)
            }
            data.append("rp_disclaimer", values?.rp_disclaimer || "");
            // data.append("cp_cta_name", values?.cp_cta_name?.trim());
            data.append("cp_cta_name", (values?.cp_cta_name ?? "").trim());
            data.append("cp_pitch", values?.cp_pitch?.trim()|| '');
            data.append("cp_destination_url", values?.cp_destination_url?.trim()|| '');
            data.append("mapped_product_title", values?.mapped_product_title?.trim() || "")
            data.append("mapped_product_cta_label", values?.mapped_product_cta_label?.trim() || "")
            data.append("mapped_product_pitch", values?.mapped_product_pitch?.trim() || "")
            data.append("mapped_product_destination_url", values?.mapped_product_destination_url?.trim() || "")
            data.append("enable_cp_pitch_for_rp", values?.enable_cp_pitch_for_rp || false)
            data.append("cp_pitch_for_rp", values?.cp_pitch_for_rp?.trim() || "")
            data.append("promotion_banner_web", values?.promotion_banner_web);
            data.append("promotion_banner_wap", values?.promotion_banner_wap);
            data.append("banner_destination", values?.banner_destination?.trim() || "")
            data.append("user_id", user?.data?.id)

            // Dispatching data
            dispatch(postResultPage(data));
          }
        }}
      >
        {({
          values,
          setFieldValue,
          errors,
          touched,
          setTouched,
          handleBlur,
          handleSubmit,
          setFieldTouched,
          isValid,
        }) => {
          console.log("...values", values, "...errors", errors, "...touched", touched)

          useEffect(() => {
            if (postBasicDetailDataError?.data?.url_alias) {
              console.log("Error Data:", postBasicDetailDataError?.data);
              alert("Alias with this name already exists");
            }
          }, [postBasicDetailDataError?.data?.url_alias]);

          const preventTyping = (event, fieldName) => {
            const fieldLengthLimits = {
              positive_feedback_percentage: 11,
              usage_count_matrix: 11,
              name: 101,
              video: 101,
              custom_exam_name: 41,
              custom_flow_type: 31,
              custom_year: 11,
              alias: 101,
              listing_desc: 201,
              page_title: 201,
              url_alias: 101,
              meta_description: 601,
              keywords: 601,
              rp_disclaimer: 351,
              cp_cta_name: 41,
              cp_destination_url: 201,
              cp_pitch: 201,
              mapped_product_title: 101,
              mapped_product_cta_label: 41,
              mapped_product_destination_url: 201,
              mapped_product_pitch: 201,
              banner_destination: 201,
              cp_pitch_for_rp: 201,
              client_banner_url: 501,
            };

            const maxLength = fieldLengthLimits[fieldName];
            const isBackspace = event.key === "Backspace";
            const currentValue = values?.[fieldName] || "";

            if (maxLength !== undefined) {
              if (!isBackspace && currentValue.length >= maxLength) {
                event.preventDefault();
              } else {
                setFieldValue(fieldName, event.target.value);
              }
            }
          };

          const handleChangeImage = (e, fieldName) => {
            const file = e.target.files[0];

            // Check if the field name is 'image' or 'secondary image'
            if (fieldName == 'image' || fieldName == 'secondary_image' || fieldName == 'sponser_logo') {
              if (file && (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg")) {
                setFieldValue(fieldName, file);
              } else {
                // Handle the error with the specific alert message
                alert("Please upload in JPG/PNG.");
                e.target.value = "";
                setFieldValue(fieldName, '');
              }
            } else if (fieldName == "client_banner") {
              if (file && (file.type === "image/gif" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "image/webp")) {
                setFieldValue(fieldName, file);
              } else {
                alert("Please upload in GIF/JPG/PNG/WEBP.");
                e.target.value = "";
                setFieldValue(fieldName, '');
              }
            } else {
              if (file && (file.type == "image/gif" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg")) {
                setFieldValue(fieldName, file);
              } else {
                // Handle the error with the specific alert message
                alert("Please upload in JPG/PNG/GIF.");
                e.target.value = "";
                setFieldValue(fieldName, '');
              }
            }
          };

          return (
            <div>
              <div
                style={{
                  backgroundColor: "#dfe6f6",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "5rem 0",
                  width: "100%",
                  boxSizing: "border-box",
                  marginBottom: "40px",
                }}
              >
                <Stepper
                  activeStep={activeStep}
                  alternativeLabel
                  style={{
                    width: "100%",
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepLabel
                        onClick={() => handleStepChange(index)}
                        style={{ cursor: "pointer" }}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>

              {/* step-1 */}
              {activeStep === 0 && (
                <BasicDetail
                  activeStep={activeStep}
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                  handleSubmit={handleSubmit}
                  predictorToolTypeData={predictorToolTypeData}
                  predictorExamDropdownData={predictorExamDropdownData}
                  basicDetailData={basicDetailData}
                  postBasicDetailData={postBasicDetailData}
                  id={id}
                  handleBlur={handleBlur}
                  showInfoTip={showInfoTip}
                  preventTyping={preventTyping}
                  handleStep1Save={() => handleStep1Save()}
                  handleChangeImage={handleChangeImage}
                  setFieldTouched={setFieldTouched}
                  dispatch={dispatch}
                  user={user}
                  setSaveNext={setSaveNext}
                  productId={postBasicDetailData?.id || id}
                  showBlockForSEO={() => showBlockForSEO()}
                />
              )

              }


              {/* step-2 */}

              {(activeStep === 1 && showBlockForSEO())
                && (
                  <InputPageAddEdit
                    activeStep={activeStep}
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    handleSubmit={handleSubmit}
                    predictorToolTypeData={predictorToolTypeData}
                    predictorExamDropdownData={predictorExamDropdownData}
                    basicDetailData={basicDetailData}
                    postBasicDetailData={postBasicDetailData}
                    predictorToolAuthorData={predictorToolAuthorData}
                    urlId={id}
                    handleBlur={handleBlur}
                    showInfoTip={showInfoTip}
                    preventTyping={preventTyping}
                    productId={id}
                    dispatch={dispatch}
                    user={user}
                    handleChangeImage={handleChangeImage}
                    setTouched={setTouched}
                    setSaveNext={setSaveNext}
                    postInputToolContentData={postInputToolContentData}
                    postInputPageFaqData={postInputPageFaqData}
                    postInputDetailData={postInputDetailData}
                    basicDetailError={basicDetailError}
                    navigate={navigate}
                    showBlockForSEO={() => showBlockForSEO()}
                  />
                )}
              {(activeStep === 1 && !showBlockForSEO()) &&
                <PermissionDenied />
              }

              {/* step-3 */}
              {
                activeStep == 2 && (
                  <ResultPage
                    activeStep={activeStep}
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    handleSubmit={handleSubmit}
                    predictorToolTypeData={predictorToolTypeData}
                    predictorExamDropdownData={predictorExamDropdownData}
                    basicDetailData={basicDetailData}
                    postBasicDetailData={postBasicDetailData}
                    id={id}
                    handleBlur={handleBlur}
                    showInfoTip={showInfoTip}
                    preventTyping={preventTyping}
                    urlId={id}
                    dispatch={dispatch}
                    user={user}
                    handleChangeImage={handleChangeImage}
                    resultFormMessage={resultFormMessage}
                    postResultPageError={postResultPageError}
                    setSaveNext={setSaveNext}
                    productId={id}
                    postResultPageData={postResultPageData}
                    showBlockForSEO={() => showBlockForSEO()}
                    inputDetailData={inputDetailData}
                    inputDetailError={inputDetailError}
                    inputToolContentError={inputToolContentError}
                    inputPageFaqError={inputPageFaqError}
                  />
                )}
            </div>
          );
        }}
      </Formik >
    </div >
  );
};

export default PredictorAddEdit;